import baseAPI from "@/api/base";
import {
  EditOpportunityStage,
  GetOpportunityStage,
  RegisterOpportunityStage,
} from "@/dtos/OpportunityStage.dto";
import {
  DELETE_OPPORTUNITY_STAGE_URL,
  EDIT_OPPORTUNITY_STAGE_URL,
  GET_OPPORTUNITY_STAGE_URL,
  REGISTER_OPPORTUNITY_STAGE_URL,
  TOGGLE_OPPORTUNITY_STAGE_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class OpportunityStage {
  static getOpportunityStages = async (
    getOpportunityStage: GetOpportunityStage
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_OPPORTUNITY_STAGE_URL, {
      params: getOpportunityStage,
    });
    return response;
  };

  static registerOpportunityStage = async (
    registerOpportunityStage: RegisterOpportunityStage
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_OPPORTUNITY_STAGE_URL, {
      ...registerOpportunityStage,
    });
    return response;
  };

  static editOpportunityStage = async (
    editOpportunityStage: EditOpportunityStage
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_OPPORTUNITY_STAGE_URL, {
      ...editOpportunityStage,
    });
    return response;
  };

  static toggleOpportunityStageIsActive = async (
    editOpportunityStage: EditOpportunityStage
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_OPPORTUNITY_STAGE_IS_ACTIVE_URL, {
      ...editOpportunityStage,
    });
    return response;
  };

  static deleteOpportunityStage = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_OPPORTUNITY_STAGE_URL}/${id}`);
    return response;
  };
}

export default OpportunityStage;
